import { cva } from '@/styled-system/css';

export const progressStepperBarRecipe = cva({
  base: {
    'position': 'absolute',
    '& [data-c11n-component="Progress.Track"]': {
      backgroundColor: 'ProgressMeter.Track.default',
    },
    '& [data-c11n-component="Progress.Range"]': {
      backgroundColor: 'ProgressMeter.Track.active',
    },
  },
  variants: {
    orientation: {
      horizontal: {
        insetBlockStart:
          'calc(({sizes.ProgressMeter.Node.focusRing.default.hover} / 2) - ({sizes.ProgressMeter.Track.weight} / 2))',
        insetInlineStart:
          'calc((var(--c11n-step-width) / 2) - {sizes.ProgressMeter.Node.marker.notStarted})',
        width:
          'calc((100% - var(--c11n-step-width)) + {sizes.ProgressMeter.Node.marker.notStarted} * 2)',
        height: 'ProgressMeter.Track.weight',
      },
      vertical: {
        'insetBlockStart':
          'calc(({lineHeights.ProgressMeter.Label.default} - {sizes.ProgressMeter.Node.marker.notStarted} - {sizes.ProgressMeter.Node.marker.notStarted}) / 2)',
        'insetInlineStart':
          'calc(({sizes.ProgressMeter.Node.focusRing.default.hover} / 2) - ({sizes.ProgressMeter.Track.weight} / 2))',
        'width': 'ProgressMeter.Track.weight',
        'height': 'calc(100% * (1 - 1 / var(--c11n-steps)) + {sizes.pipe.weight.thickest})',
        '& [data-c11n-component="Progress.Range"]': {
          width: '100%',
        },
      },
    },
  },
});
